import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import useApi from "../../hooks/useApi";

export default function ReAssignDrivers() {
  const { get } = useApi();

  const { data, isLoading, isError, error } =
    get("/admin/driver-reassignments");

  const reassignments = data?.data || [];

  // 🔍 Filters state
  const [search, setSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  // 🔎 Filter logic
  const filteredData = useMemo(() => {
    return reassignments.filter((item) => {
      const searchText = search.toLowerCase();

      const matchesSearch =
        item.order_id?.toString().includes(searchText) ||
        item.old_driver_name?.toLowerCase().includes(searchText) ||
        item.new_driver_name?.toLowerCase().includes(searchText) ||
        item.reason?.toLowerCase().includes(searchText);

      const itemDate = new Date(item.created_at)
        .toISOString()
        .split("T")[0];

      const matchesDate = selectedDate ? itemDate === selectedDate : true;

      return matchesSearch && matchesDate;
    });
  }, [reassignments, search, selectedDate]);

  // 🔄 Clear filters
  const handleClearFilters = () => {
    setSearch("");
    setSelectedDate("");
  };

  if (isLoading) return <p>Loading driver reassignments...</p>;
  if (isError) return <p className="text-danger">{error?.message}</p>;

  return (
    <>
      <div className="title-header option-title">
        <h2>Driver Reassignments</h2>
      </div>

      {/* 🔍 Filters */}
      <div className="row mb-3 g-2 align-items-center">
        <div className="col-md-5">
          <input
            type="text"
            className="form-control"
            placeholder="Search Order ID / Old Driver / New Driver / Reason"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <input
            type="date"
            className="form-control"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>

        <div className="col-md-2">
          <button
            className="btn btn-secondary w-100"
            onClick={handleClearFilters}
          >
            Clear Filters
          </button>
        </div>
      </div>

      {/* 📊 Table */}
      <div className="table-responsive">
        <table className="table theme-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Order ID</th>
              <th>Old Driver</th>
              <th>New Driver</th>
              <th>Reason</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>

                  {/* Order ID clickable */}
                  <td>
                    <Link
                      to={`/orderdetails/${item.order_id}`}
                      style={{
                        color: "#007bff",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      {item.order_id}
                    </Link>
                  </td>

                  {/* Old Driver clickable */}
                  <td>
                    {item.old_driver_id ? (
                      <Link
                        to={`/driverdetails/${item.old_driver_id}`}
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {item.old_driver_name || "No Name"}
                      </Link>
                    ) : (
                      "No Name"
                    )}
                  </td>

                  {/* New Driver clickable */}
                  <td>
                    {item.new_driver_id ? (
                      <Link
                        to={`/driverdetails/${item.new_driver_id}`}
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {item.new_driver_name || "No Name"}
                      </Link>
                    ) : (
                      "No Name"
                    )}
                  </td>

                  <td>{item.reason}</td>
                  <td>{new Date(item.created_at).toLocaleDateString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
